import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from '@/types'
import { register } from '@/store/module/register'
import { referenceData } from '@/store/module/referenceData'
import { errors } from '@/store/module/errors';

// Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  modules: {
    register,
    referenceData,
    errors,
  },
}

export default function (): StoreOptions<RootState> {
  return new Vuex.Store<RootState>(store)
}
